import React, { useEffect, useState } from "react";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { Link } from "react-router-dom";
import { unformatDate } from "../../lib/formatDate";
const TeamScores = ({
  appData,
  games,
  isTeamProfile,
  season,
  activePhase,
  activeTeam,
}) => {
  function calcualtePoints(game, team) {
    let points = 0;
    if (team === "local_team") {
      game.local_stats.forEach((element) => {
        points += Number(element.pts);
      });
    } else if (team === "visit_team") {
      game.visit_stats.forEach((element) => {
        points += Number(element.pts);
      });
    }
    return points;
  }
  return (
    <Container isTeamProfile={isTeamProfile}>
      {games !== null &&
        games.filter(
          (game) =>
            (game.local_team === activeTeam ||
              game.visit_team === activeTeam) &&
            game.season === season &&
            (activePhase === null || game.stage === activePhase)
        ).length > 0 &&
        games
          .filter(
            (game) =>
              (game.local_team === activeTeam ||
                game.visit_team === activeTeam) &&
              game.season === season &&
              (activePhase === null || game.stage === activePhase)
          )
          .sort((a, b) => unformatDate(b.date) - unformatDate(a.date))
          .map((game, index) => (
            <div className="gameContainer">
              <div className="header">
                {game.category === "LA" ? (
                  <img className="league-logo" src="/assets/logoLA.png" />
                ) : game.category === "LNB" ? (
                  <img className="league-logo" src="/assets/logoLNB.svg" />
                ) : (
                  <img className="league-logo" src="/assets/logoLA.png" />
                )}
                <div className="game-information">
                  <p className="date">{game.date}</p>
                  <p className="league">
                    {game.category === "LA"
                      ? "Liga Argentina"
                      : game.category === "LNB"
                      ? "Liga Nacional Argentina"
                      : game.category !== undefined
                      ? game.category
                      : "Liga Argentina"}{" "}
                    <br /> {game.stage}
                  </p>
                </div>
                <div
                  className={`game-result  ${
                    (game.local_team === activeTeam &&
                      calcualtePoints(game, "local_team") >
                        calcualtePoints(game, "visit_team")) ||
                    (game.visit_team === activeTeam &&
                      calcualtePoints(game, "local_team") <
                        calcualtePoints(game, "visit_team"))
                      ? "green"
                      : null
                  }`}
                >
                  <p>
                    {game.local_team === activeTeam &&
                    calcualtePoints(game, "local_team") >
                      calcualtePoints(game, "visit_team")
                      ? "G"
                      : game.visit_team === activeTeam &&
                        calcualtePoints(game, "local_team") <
                          calcualtePoints(game, "visit_team")
                      ? "G"
                      : "P"}
                  </p>
                </div>
              </div>
              <div className="content">
                <Link
                  to={`/teamProfile/${
                    appData?.teams?.filter(
                      (team) => team._id === game.local_team
                    )[0]?._id
                  }`}
                  className="teams"
                >
                  {
                    appData?.teams?.filter(
                      (team) => team._id === game.local_team
                    )[0]?.name
                  }{" "}
                </Link>
                <div className="points-container">
                  <p className="points">
                    {calcualtePoints(game, "local_team")}
                  </p>
                </div>
                <div className="points-container">
                  <p className="points">
                    {calcualtePoints(game, "visit_team")}
                  </p>
                </div>
                <Link
                  to={`/teamProfile/${
                    appData?.teams?.filter(
                      (team) => team._id === game.visit_team
                    )[0]?._id
                  }`}
                  className="teams"
                >
                  {
                    appData?.teams?.filter(
                      (team) => team._id === game.visit_team
                    )[0]?.name
                  }
                </Link>
                <div className="link-container">
                  <Link
                    to={{
                      pathname: `/app/game/${game._id}`,
                      state: { game },
                    }}
                  >
                    <p>ESTADISTICAS</p>
                    <img
                      className="right-arrow"
                      src="/assets/right-arrow.svg"
                    />
                  </Link>
                </div>
              </div>
            </div>
          ))}
    </Container>
  );
};

export default TeamScores;
